import { useEffect, useState } from 'react';
import { fetchAdminMe } from '../api/api';

// One lookup per session token: the answer only changes when someone edits the
// user's record in Mongo, and a re-login picks that up.
let cached = { token: null, promise: null };

export const checkPlatformAdmin = () => {
    const token = localStorage.getItem('token');
    if (!token) return Promise.resolve(false);
    if (cached.token !== token) {
        cached = {
            token,
            promise: fetchAdminMe()
                .then((res) => !!res.data?.isPlatformAdmin)
                .catch(() => false),
        };
    }
    return cached.promise;
};

/** `null` while loading, then true/false. */
export const usePlatformAdmin = () => {
    const [isAdmin, setIsAdmin] = useState(null);
    useEffect(() => {
        let active = true;
        checkPlatformAdmin().then((value) => active && setIsAdmin(value));
        return () => {
            active = false;
        };
    }, []);
    return isAdmin;
};
